import { gql } from "@apollo/client";

export const SEND_EMAIL_RIGHT_NOW = gql`
  mutation SendEmailRightNow($input: EmailQueueInput!) {
    sendEmailRightNow(emailQueueInput: $input)
  }
`;